import { immerable } from "immer";

export class ERPWorkOrderHeaderInfos {
  [immerable] = true;
  accountManagerEmail: string | null = null;
  clientId: string | null = null;
  projectName: string | null = null;
  projectType: string | null = null;
  accountManagerId: number | null = 0;
  clientName: string | null = null;
  projectId: number | null = 0;

  constructor(init?: Partial<ERPWorkOrderHeaderInfos>) {
    Object.assign(this, init);
  }
}
